module.exports = __webpack_public_path__ + "static/img/nested.952852a4.svg";